<template>
    <div class="table_wrap">
        <div class="c_table_wrap table_search_wrap">
            <div class="filter-show-count">    
              <el-select v-model="size" @change="changePage('size', size)">
                  <el-option v-for="(sizeData) in sizeList" :key="`size${sizeData}`" :value="sizeData"
                             :label="`${sizeData}개씩 보기`"></el-option>
              </el-select>
          </div>
            <div class="btn_wrap pr10 text_right" style="display: inline-block; float: right;">
                <el-button type="save" @click="downExecl()">미사용 엑셀 리스트 다운받기</el-button>
            </div>

        </div>

        <coupon-member-list-modal></coupon-member-list-modal>
    </div>
</template>

<script>
import couponUtil from "@/components/coupon/CouponUtil";
import CouponMemberListModal from "@/components/modal/CouponMemberListModal"
import EventBus from "@/utils/event-bus";
import {appLanguage} from "@/service/languageService";
import util from "@/mixins/util";

const {filterConfig} = couponUtil;
export default {
    name: "CouponMemberFilterDefaultLayout",
    mixins: [],
    components: {
        CouponMemberListModal
    },
    inject: ['setPage', 'setFilter'],
    provide() {
        return {}
    },
    props: {
        filterData: {
            default: () => {
                return {}
            }
        },
        paginationData: {
            default: () => {
                return {total: 0, page: 0, size: 0,}
            }
        },

    },
    data() {
        return {
            searchInput: '',
            searchInputOption:'ni',
            selectStatus: '',
            filterDate: [],
            filterStatus:'',
            filterPayType:'',

            size: 10,
            sizeList: [10, 30, 50],

            langOption:'',
            languages : appLanguage
        }
    },
    created() {
    },
    mounted() {
        this.setterFilterDataInData();

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
      setterFilterDataInData() {
        let classnames = Object.keys(this.filterData);
        classnames.forEach(classname => {
          let obj = this.filterData[classname];
          let type = filterConfig[obj.key].type;
          if (this.hasOwnProperty(classname)) {
            // this[classname] =
            if (type == 'query') {
              this[classname] = obj.query;
              if(this.hasOwnProperty(classname+'Option')) {
                this[classname+'Option'] = obj.key;
              }
            } else if (type === 'between') {
              this[classname] = [obj.start, obj.end];
            } else if (type === 'match') {
              if (isNaN(obj.value)) {
                this[classname] = obj.value;
              } else {
                this[classname] = Number(obj.value);
              }

            }

          }
        })
        this.size = this.paginationData.size;
      },
      setFilterFunc(key, value) {
        this.setFilter(key, value);
      },

      changePage(key, value) {
        this.setPage(key, value);
        this.setPage('page', 1);
      },
      checkFilterData() {
        return this.filterDate != null && this.filterDate.length > 0;
      },
        goMemberList() {


        },
        downExecl(){
          EventBus.$emit('downloadExcel');
        }
    },
    watch: {},
}
</script>
